import { useState } from "react";
import type { TemplateSlot } from "../utils/derive-template";
import { DAY_LABELS, DAY_SHORT_LABELS, WEEK_ORDER } from "../utils/derive-template";
import { ScheduleDayColumn } from "./ScheduleDayColumn";

interface ScheduleWeeklyMobileProps {
  readonly weeklySlots: ReadonlyMap<number, readonly TemplateSlot[]>;
  readonly onEditSlot: (slot: TemplateSlot) => void;
  readonly onAddSlot: (day: number) => void;
  readonly onContextMenu: (slot: TemplateSlot, anchorRect: DOMRect) => void;
}

export function ScheduleWeeklyMobile({
  weeklySlots,
  onEditSlot,
  onAddSlot,
  onContextMenu,
}: ScheduleWeeklyMobileProps) {
  const [mobileDay, setMobileDay] = useState<number>(WEEK_ORDER[0]);
  const mobileDaySlots = weeklySlots.get(mobileDay) ?? [];

  return (
    <section className="md:hidden">
      <h2 className="text-sm font-semibold text-ink mb-3">Hebdomadaire</h2>

      {/* Tab bar */}
      <div className="flex gap-1 mb-3 overflow-x-auto scrollbar-hide">
        {WEEK_ORDER.map((day) => {
          const count = weeklySlots.get(day)?.length ?? 0;
          const isActive = mobileDay === day;
          return (
            <button
              key={day}
              type="button"
              onClick={() => setMobileDay(day)}
              className={`flex flex-col items-center px-3 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors shrink-0 ${
                isActive ? "bg-accent text-white" : "bg-surface-alt text-ink-muted"
              }`}
            >
              <span>{DAY_SHORT_LABELS[day]}</span>
              <span
                className={`text-[10px] font-normal ${isActive ? "text-white/70" : "text-ink-faint"}`}
              >
                {count}
              </span>
            </button>
          );
        })}
      </div>

      {/* Active day content */}
      <ScheduleDayColumn
        dayLabel={DAY_LABELS[mobileDay]}
        slots={mobileDaySlots}
        onEditSlot={onEditSlot}
        onAddSlot={() => onAddSlot(mobileDay)}
        onContextMenu={onContextMenu}
      />
    </section>
  );
}
